import { Component } from "@angular/core";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import LocalizationConstants from "src/app/constants/localization-constants";
import { ModalComponent } from "src/app/services/modal.service";

import { ConfirmationDialogData } from "../confirmation-dialog/confirmation-dialog-modal.component";

export class ErrorConfirmationDialogData extends ConfirmationDialogData {
  requestId: string;
  additionalDetails: string[];
}

@Component({
  selector: "error-notification-modal",
  templateUrl: "./error-notification-modal.component.html",
  styleUrls: ["./error-notification-modal.component.scss"],
  standalone: false,
})
export class ErrorNotificationModalComponent
  implements ModalComponent<ErrorNotificationModalComponent, ErrorConfirmationDialogData, boolean>
{
  readonly localizationConstants = LocalizationConstants;

  title: string = "";
  content: string[] = [];
  requestId: string;
  additionalDetails: string[];

  constructor(
    public dialogRef: MatDialogRef<ErrorNotificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ErrorConfirmationDialogData,
  ) {
    this.title = this.data.title;
    this.content = this.data.content;
    this.requestId = this.data.requestId;
    this.additionalDetails = this.data.additionalDetails;
  }

  onClose() {
    this.dialogRef.close(false);
  }
}
